import React, { Component } from 'react';
import Table from '~/components/Table';

class Rosters extends Component { 
  render() {
    return (
      <div className='roster-wrapper'>
        <h3 className='roster-title site-border-color'>Game Rosters</h3>
        { this.props.rosters.length > 0 ? this.props.rosters.map((item, i) => (
          <div className='table-wrapper' key={i}>
            <span className='team-name'>{i < 1? this.props.awayTeam.mascot : this.props.homeTeam.mascot}</span>
            <Table 
              headers={this.props.headers[0]}
              data={i < 1? this.props.homePlayers : this.props.awayPlayers}
              values={this.props.headers[1]}
              navigation={i < 1? this.props.homePlayers : this.props.awayPlayers}
            />
          </div>
        )) : <div className='not-yet'>No rosters yet.</div> }
      </div>      
    )
  }
}

export default Rosters;